import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

/* eslint-disable react/forbid-prop-types */
const propTypes = {
  openEquipmentModal: PropTypes.func.isRequired,
};
/* eslint-enable react/forbid-prop-types */

const AddUserButton = (props) => {
  const { openEquipmentModal } = props;

  const equipment = { enabled: true };
  return (
    <Button bsStyle="primary" onClick={() => { openEquipmentModal(equipment); }}>Add Equipment</Button>
  );
};

AddUserButton.propTypes = propTypes;

export default AddUserButton;
